import { useWindowSize } from "react-use";
import style from "./paginateCard.module.css";
import { Fragment } from "react";

function PaginateCard({
  numberItems,
  onIndexChoose,
  count,
  numberPage,
  className = "",
}) {
  const { width } = useWindowSize();

  const items = parseInt(numberItems);
  const page = parseInt(numberPage);
  if (isNaN(items) || isNaN(page)) {
    return <Fragment></Fragment>;
  }

  const total = Math.ceil(count / numberItems);
  const nextPage = total > page;

  if (page > total || total === 1) {
    return <></>;
  }

  return (
    <div
      className={
        "d-flex justify-content-center " + (className ? className : "")
      }
    >
      <div className={style.pagination}>
        {width < 400 && total > 0 && page > 1 && (
          <button type="button" onClick={() => onIndexChoose(page - 1)}>
            &#60;&#60;
          </button>
        )}
        {total > 0 && (
          <button
            className={page === 1 ? style.active : ""}
            type="button"
            onClick={() => onIndexChoose(1)}
          >
            1
          </button>
        )}
        {width >= 400 && page - 3 > 1 && <span>...</span>}
        {width >= 400 && page - 2 > 1 && (
          <button type="button" onClick={() => onIndexChoose(page - 2)}>
            {page - 2}
          </button>
        )}
        {width >= 400 && page - 1 > 1 && (
          <button type="button" onClick={() => onIndexChoose(page - 1)}>
            {page - 1}
          </button>
        )}

        {page !== 1 && page !== total && (
          <button className={style.active}>{page}</button>
        )}

        {width >= 400 && page + 1 < total && nextPage && (
          <button type="button" onClick={() => onIndexChoose(page + 1)}>
            {page + 1}
          </button>
        )}
        {width >= 400 && page + 2 < total && nextPage && (
          <button type="button" onClick={() => onIndexChoose(page + 2)}>
            {page + 2}
          </button>
        )}

        {width >= 400 && page + 3 < total && nextPage && <span>...</span>}
        {total > 1 && (
          <button
            className={page === total ? style.active : ""}
            type="button"
            onClick={() => onIndexChoose(total)}
          >
            {total}
          </button>
        )}
        {width < 400 && page < total && (
          <button type="button" onClick={() => onIndexChoose(page + 1)}>
            &#62;&#62;
          </button>
        )}
      </div>
    </div>
  );
}

export default PaginateCard;
